import { render, staticRenderFns } from "./Passage-list.vue?vue&type=template&id=783032d4&"
import script from "./Passage-list.vue?vue&type=script&lang=js&"
export * from "./Passage-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports